export default "__VITE_ASSET__Dtf4FZY4__"